import React, {useContext} from 'react';
import styles from "./download-termsheet-prospectus.module.scss";
import logo from "../../../../../assets/security-details-download-termsheet.svg";
import SecurityService from "../../../../../services/security-service";
import {SecurityContext} from "../../../../../context/security-context";

const DownloadTermSheetProspectus = () => {
  //Set action title
  const action = 'Prospectus';

  //Initialize service
  const securityService = new SecurityService();

  //Get context data
  const { securityState } = useContext(SecurityContext);

  //Get security document pre-signed urls. (term sheet and prospectus)
  const downloadDocuments = async () => {
    const result = await securityService.getSecurityDocument(securityState.securityId);
    let newWindow = window.open(result['termsheetUrl'], '_blank', 'noopener,noreferrer');
    newWindow = window.open(result['prospectusUrl'], '_blank', 'noopener,noreferrer');
    if (newWindow) newWindow.opener = null;
  }

  return (
    <div onClick={() => downloadDocuments()} className={styles['logo']}>
      <img alt={action} src={logo} />
      <label>{action}</label>
    </div>
  );
}

export default DownloadTermSheetProspectus;
